import chineseConv from 'chinese-conv'

/**
 * 將繁體中文轉為簡體中文
 * @param {string} input
 * @returns {Promise<string>} output
 */
export default async function convertTraditionalToSimplified(input) {
  return chineseConv.sify(input)
}
